module.exports = __webpack_public_path__ + "static/img/Hamish-Davis.4e8dcc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamish-Davis.jpg
// module id = 49xV
// module chunks = 0